export default "__VITE_ASSET__4a8f53fe__"